var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 727.4 490.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb275;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.24,79.87a26.58,26.58,0,0,0-1.15-16.13c-10-23.92-57.47-26.83-106-6.49s-79.66,56.21-69.62,80.13c6.3,15,27.4,21.77,54.24,19.65-10.25,24-11.51,45.15-1.36,55.25,11.34,11.27,33.94,5.78,57.62-11.72,3.7,11.61,9.53,19.62,17.07,22,18.7,5.86,40.87-25.12,49.52-69.21,4.35-22.21,4.44-43.49,1.07-59.91A40.52,40.52,0,0,0,277.24,79.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M563.42,110.44a19.75,19.75,0,0,0-10.18-6.33c-18.74-4.38-41.12,22.85-50,60.81s-.9,72.3,17.84,76.68c11.77,2.76,25-7,35.39-24,9.95,16.59,22.11,26.56,32.59,24.86,11.71-1.91,18.24-17.87,18-39.7,8.58,2.83,15.93,2.81,20.63-.69,11.66-8.68,2.69-35.47-20-59.85-11.44-12.27-24.19-21.59-35.51-26.71A30.1,30.1,0,0,0,563.42,110.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.86,22.59A26.63,26.63,0,0,0,313,14.33c-25.37-5.4-54.82,31.91-65.77,83.34s.75,97.49,26.12,102.89c15.95,3.4,33.51-10.09,47.07-33.35,13.86,22.09,30.53,35.2,44.62,32.62,15.72-2.89,24.1-24.58,23.23-54,11.65,3.58,21.55,3.36,27.8-1.49,15.48-12,2.67-47.9-28.62-80.14-15.75-16.24-33.19-28.45-48.59-35A40.42,40.42,0,0,0,326.86,22.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.62,50.5a26.59,26.59,0,0,0-5.05-15.37c-15.56-20.75-62.28-12-104.34,19.54s-63.55,73.94-48,94.69c9.79,13,31.89,14.44,57.4,5.83-4.09,25.76-.15,46.59,12.16,53.91,13.74,8.17,34.31-2.66,53-25.41,6.42,10.36,14,16.71,21.92,17.16,19.56,1.13,33.51-34.33,31.14-79.19-1.19-22.6-6.3-43.27-13.57-58.37A40.19,40.19,0,0,0,516.62,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.76,190.18a26.56,26.56,0,0,0,16.06,1.9c25.38-5.36,37.15-51.4,26.29-102.85S134.87.43,109.49,5.78C93.53,9.15,83,28.61,80,55.37,58.37,40.8,37.82,35.58,26,43.65c-13.2,9-12.06,32.24.68,58.79-12.1,1.46-21.06,5.67-24.81,12.64-9.27,17.27,17,44.86,58.67,61.64,21,8.45,41.89,12.54,58.64,12.32A40.51,40.51,0,0,0,132.76,190.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.27,188.3A26.5,26.5,0,0,1,596,193.48c-25.89,0-46.88-42.54-46.88-95s21-95,46.88-95c16.28,0,30.62,16.81,39,42.34,18.12-18.69,37.12-28,50.33-22.57,14.76,6.08,18.42,29,11.46,57.55C708.9,79.68,718.53,82,723.62,88c12.62,15-7.35,47.31-44.59,72.29-18.76,12.58-38.32,20.88-54.73,24.11A40,40,0,0,1,611.27,188.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.75,158.7S34,264.22,78.7,308.33c0,0,77-34.61,86.37-107.25s-12-75.33-12-75.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M589.05,242.43s18.93,43.08,42.64,67.05c0,0,42.81-88.36,11.26-139.7s-56.45,10.66-56.45,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.12,153.53s292.4-284.71,378.15-48.2L573.45,157l-308.3-8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.65,50.05s28.21-103.92,92.48-12.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.7,308.33S49.75,419.45,89.58,490.94C89.58,490.94,137,358.22,78.7,308.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M631.69,309.48s-62.76,76-15.52,181.46C616.17,490.94,664,380.51,631.69,309.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.dfb78fc4.svg";
export { ForwardRef as ReactComponent };